import React, { ButtonHTMLAttributes, FC } from 'react';
import { t } from 'ttag';
import styled from '@xstyled/styled-components';
import Icon from '~/assets/icons/settings-btn.svg';

const Button = styled.button`
  background: ${p => p.theme.colors.overlayMed};
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    outline: 2px solid blue;
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 25px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }

  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 25px;
    height: 25px;
  }
`;

const StyledIcon = styled(Icon)<{
  title?: string;
}>`
  width: 21px;
  height: 21px;
`;

export const SettingsButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children,
  ...props
}) => (
  <Button
    {...props}
    aria-label={t`Settings`}
    role="button"
    aria-haspopup="true"
  >
    <StyledIcon title={t`Settings`} />
  </Button>
);
